// AUTO GENERATED FILE. DO NOT EDIT.
  import PageOrApp from 'tenants/_template/desktop/cart'

  
  export default PageOrApp;